var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { attrs: { cols: "10", sm: "8" } },
    [
      _c(
        "h3",
        { staticClass: "title-login grey-text bold text-darken-2 mb-0" },
        [_vm._v("\n    " + _vm._s(_vm.$t("account.forgotPassword")) + "\n  ")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle-login grey-text" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("account.forgotPasswordMessage")) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "forgot-form" } },
        [
          _c(
            "material-input",
            {
              staticClass: "mx-auto",
              attrs: { id: "email", "client-login": "" },
              scopedSlots: _vm._u([
                {
                  key: "input-icon",
                  fn: function () {
                    return [
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          attrs: { id: "email-icon" },
                        },
                        [_vm._v("mail_outline")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.emailReset,
                callback: function ($$v) {
                  _vm.emailReset = $$v
                },
                expression: "emailReset",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.emailReset,
                    expression: "emailReset",
                  },
                ],
                attrs: {
                  id: "email-textarea",
                  placeholder: _vm.$t("account.email"),
                  "required-indicator": "",
                  type: "email",
                },
                domProps: { value: _vm.emailReset },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.emailReset = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "email-textarea" } },
                [_vm._v("email ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "mt-5 justify-content-center",
              attrs: { id: "footer-login" },
            },
            [
              _c(
                "simple-button",
                {
                  attrs: {
                    disabled: !_vm.isValid,
                    "class-name": "rounded-pill py-2 px-5",
                    loading: _vm.loading,
                    "loading-succeeded": _vm.loadingStatus,
                  },
                  on: { click: _vm.handleSubmit },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("account.resetPassword")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("b-col", { staticClass: "footer-login", attrs: { cols: "12" } }, [
        _c("p", { staticClass: "grey-text center" }, [
          _c("a", { attrs: { href: "#/login" } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("global.actions.backToLogin")) +
                "\n      "
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }